export const getVisibleItemsWithRemaining = <T>(items: T[], visibleCount: number) => {
    const safeVisibleCount = Math.max(visibleCount, 0);
    const visibleItems = items.slice(0, safeVisibleCount);
    const remainingItems = items.slice(visibleItems.length);

    return {
        visibleItems,
        remainingItems,
        remainingCount: remainingItems.length,
    };
};
